import { useEffect, useState } from "react";
import { apiMongo } from "../../api/apiData";
import { toast } from "react-toastify";

export const Settings = () => {
  const [certificatePrice, setCertificatePrice] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await apiMongo.get(
          `${process.env.REACT_APP_MONGO_URL}/game/settings`
        );
        setCertificatePrice(response.data.certificatePrice);
      } catch (error) {
        toast.error("Nie udało się pobrać ustawień");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSaving(true);

    try {
      await apiMongo.patch(`${process.env.REACT_APP_MONGO_URL}/game/settings`, {
        certificatePrice: Number(certificatePrice),
      });
      toast.success("Zapisano ustawienia");
    } catch (error) {
      toast.error("Nie udało się zapisać ustawień");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return <p>Ładowanie...</p>;
  }

  return (
    <div className="section">
      <div className="box">
        <h2 className="title">Ustawienia ogólne</h2>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label htmlFor="certificatePrice" className="label">
              Cena certyfikatu (zakup samodzielny, poza konkursem)
            </label>
            <div className="control">
              <input
                id="certificatePrice"
                type="number"
                className="input"
                value={certificatePrice}
                onChange={(e) => setCertificatePrice(Number(e.target.value))}
                min={0.01}
                step={0.01}
              />
            </div>
          </div>

          <button
            type="submit"
            className="button is-primary mt-4"
            disabled={isSaving}
          >
            {isSaving ? "Zapisywanie..." : "Zapisz"}
          </button>
        </form>
      </div>
    </div>
  );
};
